// extracted by mini-css-extract-plugin
module.exports = {"root":"Images45_root__1xL5x","title":"Images45_title__bUo3s","images":"Images45_images__30_O8"};